import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { LoaderService } from '../loader/loader.service';

@Injectable()
export class RelatorioService {

    apiUrl: string;
    constructor(private router: Router, private http: HttpClient, private loader: LoaderService) {
        this.apiUrl = environment.apiUrl;
    }

    gerarNcm(estabelecimento, consumidor, serie, periodo) {        
        return this.http.get<any[]>(this.apiUrl + "/relatorio/ncm?estabelecimento="+estabelecimento+
                    "&consumidor="+consumidor+"&serie="+serie+"&periodo="+periodo);
    }

    gerarConsolidacao(estabelecimento, consumidor, serie, periodo) {        
        return this.http.get<any[]>(this.apiUrl + "/relatorio/consolidacao?estabelecimento="+estabelecimento+
                    "&consumidor="+consumidor+"&serie="+serie+"&periodo="+periodo);
    }

    gerarImpostos(estabelecimento, consumidor, serie, periodo) {        
        return this.http.get<any[]>(this.apiUrl + "/relatorio/impostos?estabelecimento="+estabelecimento+
                    "&consumidor="+consumidor+"&serie="+serie+"&periodo="+periodo);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/relatorio/relatorio.service.ts